import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import InvoiceTable from "./InvoiceTables";

function DoctorTables({ data, setIsLoading, isLoading, filters, flow }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [paginatedData, setPaginatedData] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  // Handle pagination
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRecordsPerPageChange = (e) => {
    setRecordsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page on change
  };

  // Get the current records for the page
  useEffect(() => {
    setIsLoading(true);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = data?.slice(indexOfFirstRecord, indexOfLastRecord);
    setPaginatedData(currentRecords);
    setIsLoading(false);
  }, [currentPage, recordsPerPage, data]);

  // Fetch data for InvoiceTable when a doctor is selected
  const fetchInvoiceData = async (doctor) => {
    if (flow != "surgerypackage") {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/mis-invoice/list`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            location_id: doctor.CenterId.toString(),
            defination: doctor["Doctor Name"],
            startDate: filters?.startDate,
            endDate: filters?.endDate,
          }),
        }
      );

      const result = await response.json();
      setSelectedDoctor({ ...doctor, invoiceData: result });
      setIsPopupOpen(true);
    } else {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/mis-invoice/list/surgery-package`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            location_id: doctor.CenterId.toString(),
            defination: doctor["Doctor Name"],
            startDate: filters?.startDate,
            endDate: filters?.endDate,
          }),
        }
      );

      const result = await response.json();
      setSelectedDoctor({ ...doctor, invoiceData: result });
      setIsPopupOpen(true);
    }
  };

  // Calculate total pages
  const totalPages = Math.ceil(data?.length / recordsPerPage);

  const paginationButtonStyle = {
    padding: "6px 12px",
    backgroundColor: "#003366",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    margin: "0 5px",
    transition: "background-color 0.3s ease",
  };

  return (
    <div>
      <div
        style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}
      >
        <label style={{ fontWeight: "bold", marginRight: "10px" }}>
          Records per page:{" "}
        </label>
        <select
          onChange={handleRecordsPerPageChange}
          value={recordsPerPage}
          style={{
            padding: "6px 12px",
            fontSize: "14px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            backgroundColor: "#f8f8f8",
            outline: "none",
            cursor: "pointer",
          }}
        >
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={data?.length}>All</option>
        </select>
      </div>

      {/* Table */}
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#003366", color: "#fff" }}>
            <th style={{ padding: "12px 15px", textAlign: "left" }}>
              Doctor Name
            </th>
            <th style={{ padding: "12px 15px", textAlign: "left" }}>Center</th>
            <th style={{ padding: "12px 15px", textAlign: "left" }}>
              Net Billing
            </th>
            <th style={{ padding: "12px 15px", textAlign: "left" }}>Payable</th>
            <th style={{ padding: "12px 15px", textAlign: "left" }}>Pending</th>
            <th style={{ padding: "12px 15px", textAlign: "center" }}>
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                <span>Loading...</span>
              </td>
            </tr>
          ) : paginatedData?.length > 0 ? (
            paginatedData.map((item, index) => (
              <tr
                key={item.ipdId}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f9fafb" : "#d3dfeb", // Subtle dual-tone styling
                  transition: "background-color 0.3s ease",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.backgroundColor = "#e2e8f0")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.backgroundColor =
                    index % 2 === 0 ? "#f9fafb" : "#d3dfeb")
                }
              >
                <td style={{ padding: "12px 15px" }}>{item["Doctor Name"]}</td>
                <td style={{ padding: "12px 15px" }}>{item["Center"]}</td>
                <td style={{ padding: "12px 15px" }}>
                  {item["Total Net Payable"]}
                </td>
                <td style={{ padding: "12px 15px" }}>{item["Paid"]}</td>
                <td style={{ padding: "12px 15px" }}>{item["Not Paid"]}</td>
                <td style={{ textAlign: "center", padding: "12px 15px" }}>
                  {/* View Button */}
                  <button
                    onClick={() => fetchInvoiceData(item)}
                    style={{
                      padding: "6px 12px",
                      backgroundColor: "#003366",
                      color: "#fff",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                      transition: "background-color 0.3s ease",
                    }}
                    onMouseOver={(e) =>
                      (e.target.style.backgroundColor = "#1e3a8a")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.backgroundColor = "#003366")
                    }
                  >
                    View
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <button
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
            style={paginationButtonStyle}
          >
            First
          </button>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            style={paginationButtonStyle}
          >
            Prev
          </button>
          {[...Array(totalPages).keys()].map((page) => (
            <button
              key={page + 1}
              onClick={() => handlePageChange(page + 1)}
              disabled={currentPage === page + 1}
              style={{
                ...paginationButtonStyle,
                backgroundColor:
                  currentPage === page + 1 ? "#003366" : "#e6e6e6",
                color: currentPage === page + 1 ? "#fff" : "#000",
              }}
            >
              {page + 1}
            </button>
          ))}
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={paginationButtonStyle}
          >
            Next
          </button>
          <button
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
            style={paginationButtonStyle}
          >
            Last
          </button>
        </div>
      )}

      {/* Popup Dialog for InvoiceTable */}
      <Dialog
        open={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        maxWidth="xl"
        fullWidth
      >
        <DialogTitle>Invoice Details</DialogTitle>
        <DialogContent>
          {selectedDoctor && (
            <InvoiceTable
              data={selectedDoctor.invoiceData}
              setIsLoading={setIsLoading}
              isLoading={isLoading}
              filters={filters}
              selectedDoctor={selectedDoctor}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsPopupOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default DoctorTables;
